import GlobalAxios from "../axios/axios-config";
import {
  IDoctorAgenda,
  IDoctorAgendaByIdentifierParams,
  IDoctorAgendaParams,
} from "../models/doctor-agenda";
import { Extension } from "../models/intalled-extensions";

const DOCTOR_AGENDA_ROUTE =
  process.env.REACT_APP_CALENDAR + "/api/v1/tasy/CalendarAllAppointment";

class DoctorAgendaService {
  getAll(searchParams: IDoctorAgendaParams) {
    return GlobalAxios.get<IDoctorAgenda[]>(DOCTOR_AGENDA_ROUTE, {
      params: { ...searchParams },
      paramsSerializer: { indexes: null },
      headers: { extensionCode: Extension.DOCTOR_AGENDA },
    });
  }

  getByIdentifier(searchParams: IDoctorAgendaByIdentifierParams) {
    return GlobalAxios.get<IDoctorAgenda[]>(DOCTOR_AGENDA_ROUTE, {
      params: { ...searchParams },
      paramsSerializer: { indexes: null },
      headers: { extensionCode: Extension.DOCTOR_AGENDA },
    });
  }
}

export default DoctorAgendaService;
